<ngx-spinner size="medium" type="ball-clip-rotate">
  <p class="text-white">Loading...</p></ngx-spinner
>
<router-outlet></router-outlet>
